import React from "react";

interface Props {
  of: any[];
  render: (item: any, index: number, arr: any[]) => unknown;
}

export const Each = ({ of, render }: Props) => {
  return (
    <>
      {of.map((item, index, arr) => {
        return render(item, index, arr);
      })}{" "}
    </>
  );
};
